import React from 'react'
import { Flex, Box } from 'rebass'
import { css, keyframes } from 'styled-components'
import useAudio from 'react-use/lib/useAudio'
import Layout from '../components/layout'
import SEO from '../components/seo'
import { Facebook, Radio, Instagram, IconWithLink } from '../components/icons'
import { BigLetters } from '../components/Text'
import useMixlr from '../hooks/useMixlr'
import theme from '../../theme'

const bouncy = keyframes`
  from {
    transform: scale(1) rotate(0deg);
  }

  50% {
    transform: scale(1.2) rotate(-5deg);
  }

  50% {
    transform: scale(1.1) rotate(5deg);
  }

  to {
    transform: scale(1);
  }
`
const liveCss = css`
  animation: ${bouncy} 1s infinite ease-in-out;
  &:after {
    content: 'LIVE';
    color: ${theme.colors.red};
    font-size: 10px;
    display: flex;
    margin-top: -5px;
    justify-content: center;
  }
`

const IndexPage = () => {
  const [isLive, feed] = useMixlr()
  const [audio, state, controls] = useAudio({
    src: feed,
    autoPlay: false,
  })

  const toggleRadio = () => {
    if (!state.isPlaying) {
      controls.play()
    } else {
      controls.pause()
    }
  }
  return (
    <Layout>
      <Flex justifyContent="space-between" width={1} my={2}>
        {audio}
        <Box>
          <IconWithLink icon={Facebook} link="https://www.facebook.com/events/594049661033082/" />
          <IconWithLink link="https://www.instagram.com/plxplxplx/" icon={Instagram} />
          <Box
            mr={2}
            width="31px"
            css={css`
              ${isLive ? liveCss : ''}
            `}
          >
            <Radio handleClick={toggleRadio} />
          </Box>
        </Box>
      </Flex>

      <SEO title="PLX Tjärö 2019" keywords={['festival', 'tjärö']} />
      <Box pt={['0vh', 6]} pb={['16vh', 6]}>
        <BigLetters fontSize={[6, 7, 7, '90px']}>
          PLX
          <br />
          TJÄRÖ
          <br />
          22—25 AUG
          <br />
          2019
        </BigLetters>
      </Box>
    </Layout>
  )
}

export default IndexPage
